import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge
const removeBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
  
  // Also check for dynamically added badges
  document.querySelectorAll('a[href*="emergent"]').forEach(el => {
    if (el.textContent?.includes('Emergent') || el.id?.includes('emergent')) {
      el.remove();
    }
  });
};

// Run on load and periodically
removeBadge();
setInterval(removeBadge, 1000);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
